import home from './home'

const pageRouters = [
  home
]

export default pageRouters
